import { VerticalTabs } from "@components/VerticalTabs";
import {
  matchPath,
  Navigate,
  useLocation,
  useNavigate
} from "react-router-dom";

import { Stack, useTheme } from "@bps/fluent-ui";
import { SystemOmniTabs } from "./system-omni-tabs.constants";

export const SystemOmniSections: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  const onSectionChange = (nextId: string) => {
    navigate(nextId);
  };

  const match = matchPath("/system/omni/:selectedTab", location.pathname);
  const selectedTab = match?.params?.selectedTab;

  if (!selectedTab) {
    return <Navigate to={SystemOmniTabs.Operations.Reports.id} replace />;
  }
  return (
    <Stack
      tokens={{
        childrenGap: theme.spacing.m
      }}
    >
      <VerticalTabs
        title="Operations"
        tabs={Object.values(SystemOmniTabs.Operations)}
        selectedTab={selectedTab}
        onSelectedTabChange={onSectionChange}
      />
    </Stack>
  );
};
